import { MediaCreateFileRequest } from '@/libs/Api/Media'
import Helper from '@/libs/Helper'

export default class UploadAdapter {
  constructor(loader) {
    // The file loader instance to use during the upload.
    this.loader = loader
  }

  async sendCreateFileRequest(file) {
    let result = ''
    try {
      let _this = this
      let createFile = new MediaCreateFileRequest(_this)
      let myForm = await Helper.makeFormData({
        uploadFile: file,
        type: 'CKEditor',
      })
      createFile.setForm(myForm)
      await createFile.sendFormData((response) => {
        if (response.isSuccess) {
          result = response.data
        }
      }, (error) => {
        console.log(error)
      })
    }
    catch (error) {
      console.error(error)
    }
    return result
  }

  // Starts the upload process.
  async upload() {
    return new Promise(async (resolve, reject) => {
      let pictureUrl = await this.sendCreateFileRequest(await this.loader.file)
      resolve({ default: pictureUrl })
    })
  }

  // Aborts the upload process.
  abort() {
    //
  }
}
